<table [formGroup]="formArray.parent">
  <thead>
    <tr>
      <th class="title">Plano de Ação</th>
      <th class="text-center">Status</th>
      <th class="text-center">Término planejado</th>
      <th class="text-center">Término previsto</th>
      <th class="text-center"></th>
      <th class="text-center">Atualização</th>
      <th class="text-center"></th>
    </tr>
  </thead>
  <tbody formArrayName="actions" *ngIf="currentItem">
    <ng-container *ngFor="let com of formArray?.controls; let i_pf_i_c = index"  [formGroupName]="i_pf_i_c">
      <tr class="tr-0"  *ngIf="currentItem[i_pf_i_c] as variable" >
        <td class="">{{variable?.title}}
          <span class="info-text" *ngIf="variable.resp_nome">
            <br/>Resp.: {{variable?.resp_nome}}
            
            <span class="icon-table icon-button">
              <img src="assets/images/svgs/Admin.svg" alt="Exibir detalhes do usuário" tooltip="Exibir detalhes do usuário" placement="bottom" 
              (click)="variable.show_resp = variable['show_resp'] != null? !variable['show_resp']:true">
            </span>
            
            <span class="info-text" *ngIf="variable.show_resp">
              <br/>E-mail.: {{variable?.resp_email}}
              <br/>Telefone.: ({{variable?.resp_ddd}}) {{variable?.resp_tel}}
            </span>
          </span>
          <span class="info-text" *ngIf="!variable.resp_nome">
            <br/>{{variable?.responsible}}
          </span>
          <span class="info-text" *ngIf="variable.lockdown_id">
            <br/>Solicitado nova informação em 
            {{variable.lockdown_dt | date: 'dd/MM/YYYY H:mm:s'}}
            <i class="icon-exclamation-sign" (click)="variable.show_managerInfo = true"></i>
            <span class="info-text" *ngIf="variable.show_managerInfo">
              <br/>Solicitante.: {{variable?.lockdown_resp}}
            </span>
          </span>
        </td>
        <td class="text-center">{{variable?.status ?? 'NA'}}</td>
        <td class="text-center">{{variable?.deadline_original | date: 'dd/MM/YYYY'}}</td>
        <td class="text-center">{{variable?.deadline | date: 'dd/MM/YYYY'}}</td>
        <td class="text-center">
          <div class="dot dot-issue-{{variable?.status1 ?? 0}}"></div>
          <strong class="text-danger" *ngIf="variable?.diff_days">
            <br/>{{variable?.diff_days*-1}}
          </strong>
        </td>
        <td>
          {{variable?.user}}
          <br/>{{variable?.ctr_dth_atu | date: 'dd/MM/YYYY'}}
        </td>
        <td class="text-center">
          <span class="icon-table icon-button" *ngIf="variable?.description" (click)="variable['show_description'] = variable['show_description'] != null? !variable['show_description']:true">
            <img src="assets/images/svgs/lupa{{variable?.show_description?'-menos':''}}.svg" alt="Consultar" tooltip="Consultar" placement="bottom">
          </span>
        </td>
      </tr>
      <ng-container *ngIf="currentItem[i_pf_i_c] as variable" >
        <tr *ngIf="variable?.show_description == true">
          <td colspan="7"  class="break-word td-description">
            <strong>Situação: </strong>
            {{variable?.description}}
          </td>
        </tr>
      </ng-container>
    </ng-container>
  </tbody>
</table> 
